import React from 'react';
import './FloatingBackButton.css';
import PageButton from '../PageButton/PageButton';

/**
 * Круглая кнопка «назад» в левом верхнем углу страницы.
 *
 * Раньше эта кнопка копировалась на каждой странице отдельно — с одинаковой
 * разметкой и побайтово одинаковыми стилями под своим именем класса (а страница
 * заданий и вовсе переиспользовала класс страницы обучения). Здесь она одна на
 * всех: новая страница получает ее одной строкой и не заводит своих стилей.
 */
const FloatingBackButton = ({onBack, pageId, buttonId = 'back_floating'}) => (
  <PageButton
    className="floating-back-button"
    onClick={onBack}
    pageId={pageId}
    buttonId={buttonId}
  >
    <img
      className="floating-back-button_icon"
      src="/img/icons/back_navigation.png"
      alt="Назад"
      title="Назад"
    />
  </PageButton>
);

export default FloatingBackButton;
